import { useAsyncExecutor } from "async-executor-hook";
import { Paginator } from "primereact/paginator";
import { useEffect, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import { generateSequentialArray } from "../../common/utils";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import AdditionalRucsModal from "../AdditionalVolanteModal/AdditionalRucsModal";
import CommentModal from "../CommentModal/CommentModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {
  Container,
  FakeRow,
  Row,
  TableBody,
  TableHeader,
} from "../DocumentManagement/DocumentManagementSharedStyles";
import FileUploadAuthorizationModal from "../FileUploadAuthorizationModal/FileUploadAuthorizationModal";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import StatusTag from "../StatusTag/StatusTag";
import { convertThirdAgentResponse } from "./convertThirdAgentResponse";
import { IdDiv, Title } from "./ThirdPartyAuthStyles";
import {
  AuthFilters,
  formatFilters,
  INITIAL_FILTERS,
} from "./ThirdPartyFilters";

const ITEMS_PER_PAGE = 10;

const GRID_TEMPLATE_COLUMNS = "repeat(3, 1fr)";

const TITLES = {
  consignee: "IMPORTADOR",
  status: "ESTADO",
  thirdParty: "RUC FACTURABLE",
};

function ThirdPartyAuth() {
  const [filters, updateFilters] = useState(INITIAL_FILTERS);
  const [messageErrorVolantes, setMessageErrorVolantes] = useState("");
  const [showModalErrorVolantes, setShowModalErrorVolantes] = useState(false);

  const dataThirdPartyVolante = useAsyncExecutor(
    async ({ page, filters }) => {
      const params = formatFilters(filters);
      const paramsSearch = {
        ...params,
        order: "descending",
        page_size: ITEMS_PER_PAGE,
        page: page ?? 1,
      };
      return await networkBackendRequest(
        "/volantes/third-party-billing-authorization-agent/",
        HTTP_METHODS.GET,
        paramsSearch
      )
        .then((resp) => resp.json())
        .then(convertThirdAgentResponse);
    },
    {
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setMessageErrorVolantes(errorMessage);
        setShowModalErrorVolantes(true);
      },
    }
  );

  useEffect(() => {
    dataThirdPartyVolante.execute({ filters });
    // eslint-disable-next-line
  }, []);

  const [showModal, updateShowModal] = useState(false);
  const [selectedVolante, updateSelVolante] = useState(0);
  const [otherRucInfo, updateOtherRucInfo] = useState(null);

  const auxiliaryArray = generateSequentialArray(ITEMS_PER_PAGE);
  const [volanteComment, updateVolanteComment] = useState("");
  const [showCommentModal, updateShowCommentModal] = useState(false);
  const [showOtherRucModal, updateShowOtherRucModal] = useState(false);
  const [thirdName, updateThirdName] = useState("");
  const [thirdRuc, updateThirdRuc] = useState("");

  const updateSelected = (volante) => {
    updateSelVolante(volante.id);
    updateVolanteComment(volante.thirdPartyComment);
    updateThirdName(volante.thirdPartyName);
    updateThirdRuc(volante.thirdPartyRuc);
    updateShowCommentModal(true);
  };
  const hideModal = () => {
    updateShowModal(!showModal);
  };

  const toggleCommentModal = () => {
    updateShowCommentModal(!showCommentModal);
  };

  const toggleOtherRucModal = () => {
    updateShowOtherRucModal((showOtherRuc) => !showOtherRuc);
  };
  const hideOtherRucModal = () => {
    updateShowOtherRucModal(false);
  };
  const [showTerceros, setShowTerceros] = useState(false);
  const showModalTercero = () => {
    setShowTerceros(!showTerceros);
  };
  const hideTodoModal = () => {
    updateShowModal(false);
    setShowTerceros(false);
  };
  const [showAndHideModalParty, updateShowAndHideModalParty] = useState(false);

  const showPartyModal = () => {
    updateShowAndHideModalParty(true);
  };

  const [showConfirmationModalThirdPaty, setShowConfirmationModalThirdPaty] =
    useState(false);

  const [showModalOthersRucGV, setShowModalOthersRucGV] = useState(false);
  const [showModalMessageOthersRucGV, setShowModalMessageOthersRucGV] =
    useState("");
  return (
    <div>
      {showModalOthersRucGV && showModalMessageOthersRucGV && (
        <ConfirmationModal
          title={"Atención"}
          message={showModalMessageOthersRucGV}
          toggleModal={() => {
            setShowModalOthersRucGV(false);
            setShowModalMessageOthersRucGV("");
          }}
          onAccept={() => {
            setShowModalOthersRucGV(false);
            setShowModalMessageOthersRucGV("");
          }}
        />
      )}
      {showConfirmationModalThirdPaty && (
        <ConfirmationModal
          title={"Documentos subidos con éxito"}
          message={
            "La carga de los documentos ha sido exitosa. Haga clic en entendido o cierre el diálogo para continuar."
          }
          toggleModal={() => {
            updateShowModal(false);
            setShowTerceros(false);
            setShowConfirmationModalThirdPaty(false);
            dataThirdPartyVolante.retry();
          }}
          onAccept={() => {
            updateShowModal(false);
            setShowTerceros(false);
            setShowConfirmationModalThirdPaty(false);
            dataThirdPartyVolante.retry();
          }}
        />
      )}

      <Title>Mis Autorizaciones</Title>
      <Authorization actions={["volante.get_volante_third_party_auth"]}>
        <AuthFilters
          onQuery={(filters) => {
            dataThirdPartyVolante.execute({ filters });
            updateFilters(filters);
          }}
        />
      </Authorization>
      {dataThirdPartyVolante.isSuccess &&
        dataThirdPartyVolante.data.volantes.length === 0 && (
          <StandaloneMessage>
            No se encontraron parámetros de facturación a terceros.
          </StandaloneMessage>
        )}
      {dataThirdPartyVolante.isError && (
        <div>
          Algo salió mal
          <button
            type="button"
            onClick={() => {
              dataThirdPartyVolante.retry();
            }}
          >
            Reintentar
          </button>
        </div>
      )}
      {dataThirdPartyVolante.isLoading &&
        auxiliaryArray.map((_, index) => {
          return <FakeRow key={index} />;
        })}

      {dataThirdPartyVolante.isSuccess &&
        dataThirdPartyVolante.data.volantes.length > 0 && (
          <Container gridTemplateColumns={GRID_TEMPLATE_COLUMNS}>
            <Authorization actions={["volante.get_volante_third_party_auth"]}>
              <TableHeader className="item-container">
                <div className="left-align">{TITLES.consignee}</div>
                <div>{TITLES.status}</div>
                <div>{TITLES.thirdParty}</div>
              </TableHeader>
              <TableBody>
                <Authorization
                  actions={["volante.get_volante_third_party_auth"]}
                >
                  {dataThirdPartyVolante.data.volantes.map((volante) => {
                    const className = `item-container ${
                      volante.status.label === "Rechazado" ? "clickable" : ""
                    }`;
                    return (
                      <Row
                        key={volante.id}
                        className={className}
                        onClick={() => {
                          if (volante.status.label === "Rechazado")
                            updateSelected(volante);
                        }}
                      >
                        <div className="attribute left-align">
                          <div className="titles">{TITLES.consignee}</div>
                          <div className="left-align">
                            <div>{volante.consigneeName}</div>
                            <IdDiv>{volante.id}</IdDiv>
                          </div>
                        </div>
                        <div className="attribute">
                          <div className="titles">{TITLES.status}</div>
                          <Authorization
                            actions={[
                              "volante.get_volante_third_party_auth",
                              "volante.update_volante_third_party_auth",
                            ]}
                          >
                            <div>
                              <StatusTag status={volante.status} />
                            </div>
                          </Authorization>
                        </div>
                        <div className="attribute">
                          <div className="titles">{TITLES.thirdParty}</div>
                          <div>{volante.thirdPartyName}</div>
                        </div>
                      </Row>
                    );
                  })}
                </Authorization>
              </TableBody>
            </Authorization>
          </Container>
        )}
      {dataThirdPartyVolante.isSuccess &&
        dataThirdPartyVolante.data.volantes.length > 0 && (
          <div className="flex-paginator">
            <Authorization actions={["volante.get_volante_third_party_auth"]}>
              <Paginator
                first={
                  (dataThirdPartyVolante.data.page - 1) *
                  dataThirdPartyVolante.data.page_size
                }
                rows={dataThirdPartyVolante.data.page_size}
                totalRecords={dataThirdPartyVolante.data.count}
                onPageChange={(e) => {
                  const targetPage =
                    e.first / dataThirdPartyVolante.data.page_size;
                  dataThirdPartyVolante.execute({
                    page: targetPage + 1,
                    filters,
                  });
                }}
              />
            </Authorization>
          </div>
        )}

      {messageErrorVolantes && showModalErrorVolantes && (
        <ConfirmationModal
          message={messageErrorVolantes}
          onAccept={() => {
            setShowModalErrorVolantes(false);
          }}
          title={`Atención`}
          toggleModal={() => {
            setShowModalErrorVolantes(false);
          }}
        />
      )}

      {showCommentModal && (
        <CommentModal
          toggleModal={toggleCommentModal}
          title="Documento rechazado"
          message={volanteComment}
          onAccept={() => {
            hideModal();
            toggleCommentModal();
            showPartyModal();
          }}
        />
      )}
      <Authorization
        actions={[
          "files.upload_files",
          "volante.update_volante_third_party_auth",
        ]}
      >
        {showModal || showTerceros ? (
          <FileUploadAuthorizationModal
            volanteId={selectedVolante}
            hideModal={hideModal}
            otherRucInfo={otherRucInfo}
            onChangeRuc={toggleOtherRucModal}
            hideTodoModal={hideTodoModal}
            updateOtherRucInfo={updateOtherRucInfo}
            thirdRuc={thirdRuc}
            thirdName={thirdName}
            showAndHideModalParty={showAndHideModalParty}
            setShowConfirmationModalThirdPaty={
              setShowConfirmationModalThirdPaty
            }
          />
        ) : null}
      </Authorization>
      <Authorization actions={["billable-ruc.get_billable_rucs"]}>
        {showOtherRucModal ? (
          <AdditionalRucsModal
            toggleModal={() => {
              hideModal();
              toggleOtherRucModal();
            }}
            updateOtherRucInfo={updateOtherRucInfo}
            showModalTercero={showModalTercero}
            hideTodoModal={hideTodoModal}
            hideOtherRucModal={hideOtherRucModal}
            setShowModalOthersRucGV={setShowModalOthersRucGV}
            setShowModalMessageOthersRucGV={setShowModalMessageOthersRucGV}
            updateShowOtherRucModal={updateShowOtherRucModal}
          />
        ) : null}
      </Authorization>
    </div>
  );
}

export default ThirdPartyAuth;
